import { selectors as streamSelectors } from '@wix/da-shared-react/pkg/Stream';
import { getState } from './state';
import { getList } from './identity';
import { PROMOTIONS_STREAM_ID } from '../../constants';
import { getDrawerStreamId } from '../../utils';
import { getActiveFolder } from './options';
export function getHasGroups(state) {
    var _getState_drawer, _getState;
    return ((_getState = getState(state)) === null || _getState === void 0 ? void 0 : (_getState_drawer = _getState.drawer) === null || _getState_drawer === void 0 ? void 0 : _getState_drawer.hasGroups) || getList(state).length > 1;
}
export function getHasUnread(state) {
    return getList(state).some((item)=>item.newCount && item.newCount > 0);
}
export function getUnreadCount(state) {
    return getList(state).reduce((acc, curr)=>acc + curr.newCount, 0);
}
export const getDrawerElninos = (state)=>{
    var _streamSelectors_getItems;
    return (_streamSelectors_getItems = streamSelectors.getItems(state, PROMOTIONS_STREAM_ID)) !== null && _streamSelectors_getItems !== void 0 ? _streamSelectors_getItems : [];
};
export function getActiveDrawerStreamParams(state) {
    return {
        folder: getActiveFolder(state)
    };
}
export function getActiveDrawerStreamId(state) {
    return getDrawerStreamId(getActiveDrawerStreamParams(state));
}
export function isDrawerEmpty(state) {
    const streamId = getActiveDrawerStreamId(state);
    if (!streamId) {
        return false;
    }
    if (!streamSelectors.isInitialized(state, streamId)) {
        return false;
    }
    const stream = streamSelectors.getStream(state, streamId);
    return stream.items.length === 0 && !stream.isFetching && !stream.hasMore;
}
export function getLatestTs(state) {
    var _stream_items__bucket, _stream_items_;
    const streamId = getActiveDrawerStreamId(state);
    if (!streamId) {
        return false;
    }
    if (!streamSelectors.isInitialized(state, streamId)) {
        return false;
    }
    const stream = streamSelectors.getStream(state, streamId);
    return (_stream_items_ = stream.items[0]) === null || _stream_items_ === void 0 ? void 0 : (_stream_items__bucket = _stream_items_.bucket) === null || _stream_items__bucket === void 0 ? void 0 : _stream_items__bucket.ts;
}
export function getReplyMessageTypeFromDrawerStream(state, msgId) {
    const streamId = getActiveDrawerStreamId(state);
    if (!streamId) {
        return false;
    }
    if (!streamSelectors.isInitialized(state, streamId)) {
        return false;
    }
    const stream = streamSelectors.getItems(state, streamId);
    const drawerItem = stream.find((item)=>{
        var _item_message;
        return (item === null || item === void 0 ? void 0 : (_item_message = item.message) === null || _item_message === void 0 ? void 0 : _item_message.messageId) === msgId;
    });
    if (!drawerItem) {
        return false;
    }
    return drawerItem.message.type;
}
